import differenceBy from './differenceBy';
import { Breadcrumb } from '../types/api/v4/boats/search';

/**
 * removes breadcrumbs based on parentBreadcrumbs
 * @param breadcrumbs an array of breadcrumbs to filter
 * @param parentBreadcrumbs breadcrumbs to remove
 * @returns breadcrumbs that aren't in parentBreadcrumbs array or the last breadcrumb never []
 */

const getBreadcrumbs = (
  breadcrumbs: Breadcrumb[],
  parentBreadcrumbs: Breadcrumb[],
): Breadcrumb[] => {
  if (breadcrumbs === null) {
    return parentBreadcrumbs;
  }
  const result = differenceBy(breadcrumbs, parentBreadcrumbs, ({ name }) => name);
  if (result.length === 0) { // return at least the last crumb
    return breadcrumbs.slice(breadcrumbs.length - 1);
  }
  return result;
};

export default getBreadcrumbs;
